/* eslint-disable react/no-unknown-property */
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const ComplianzBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="cmplz-cookiebanner banner-1 optin cmplz-bottom-right cmplz-categories-type-view-preferences cmplz-categories-visible cmplz-dismissed"
        aria-modal="true"
        data-nosnippet="true"
        role="dialog"
        aria-live="polite"
        aria-labelledby="cmplz-header-1-optin"
        aria-describedby="cmplz-message-1-optin"
      >
        <div className="cmplz-header">
          <div className="cmplz-logo" />
          <div className="cmplz-title" id="cmplz-header-1-optin">
            Manage Cookie Consent
          </div>
          <div className="cmplz-close" role="button" aria-label="close-dialog">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="times"
              className="svg-inline--fa fa-times fa-w-11"
              role="img"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 352 512"
            >
              <path
                fill="currentColor"
                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
              />
            </svg>
          </div>
        </div>
        <div className="cmplz-divider cmplz-divider-header" />
        <div className="cmplz-body">
          <div className="cmplz-message" id="cmplz-message-1-optin">
            To provide the best experiences, we use technologies like cookies to store and/or access
            device information. Consenting to these technologies will allow us to process data such
            as browsing behavior or unique IDs on this site. Not consenting or withdrawing consent,
            may adversely affect certain features and functions.
          </div>
          <div className="cmplz-categories">
            <details className="cmplz-category cmplz-functional">
              <summary>
                <span className="cmplz-category-header">
                  <span className="cmplz-category-title">Functional</span>
                  <span className="cmplz-always-active">
                    <span className="cmplz-banner-checkbox">
                      <label className="cmplz-label" htmlFor="cmplz-functional-optin">
                        <input
                          type="checkbox"
                          id="cmplz-functional-optin"
                          data-category="cmplz_functional"
                          className="cmplz-consent-checkbox cmplz-functional"
                          size={40}
                          value="1"
                        />
                        <span className="screen-reader-text">Functional</span>
                      </label>
                    </span>
                    {t('consent.always_active')}
                  </span>
                  <span className="cmplz-icon cmplz-open">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18">
                      <path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z" />
                    </svg>
                  </span>
                </span>
              </summary>
              <div className="cmplz-description">
                <span className="cmplz-description-functional">
                  The technical storage or access is strictly necessary for the legitimate purpose
                  of enabling the use of a specific service explicitly requested by the subscriber
                  or user, or for the sole purpose of carrying out the transmission of a
                  communication over an electronic communications network.
                </span>
              </div>
            </details>
            <details className="cmplz-category cmplz-statistics">
              <summary>
                <span className="cmplz-category-header">
                  <span className="cmplz-category-title">Statistics</span>
                  <span className="cmplz-banner-checkbox">
                    <input
                      type="checkbox"
                      id="cmplz-statistics-optin"
                      data-category="cmplz_statistics"
                      className="cmplz-consent-checkbox cmplz-statistics"
                      size={40}
                      value="1"
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label className="cmplz-label" htmlFor="cmplz-statistics-optin">
                      <span className="screen-reader-text">Statistics</span>
                    </label>
                  </span>
                  <span className="cmplz-icon cmplz-open">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18">
                      <path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z" />
                    </svg>
                  </span>
                </span>
              </summary>
              <div className="cmplz-description">
                <span className="cmplz-description-statistics">
                  The technical storage or access that is used exclusively for statistical purposes.
                </span>
                <span className="cmplz-description-statistics-anonymous">
                  The technical storage or access that is used exclusively for anonymous statistical
                  purposes. Without a subpoena, voluntary compliance on the part of your Internet
                  Service Provider, or additional records from a third party, information stored or
                  retrieved for this purpose alone cannot usually be used to identify you.
                </span>
              </div>
            </details>
            <details className="cmplz-category cmplz-marketing">
              <summary>
                <span className="cmplz-category-header">
                  <span className="cmplz-category-title">Marketing</span>
                  <span className="cmplz-banner-checkbox">
                    <input
                      type="checkbox"
                      id="cmplz-marketing-optin"
                      data-category="cmplz_marketing"
                      className="cmplz-consent-checkbox cmplz-marketing"
                      size={40}
                      value="1"
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label className="cmplz-label" htmlFor="cmplz-marketing-optin">
                      <span className="screen-reader-text">Marketing</span>
                    </label>
                  </span>
                  <span className="cmplz-icon cmplz-open">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18">
                      <path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z" />
                    </svg>
                  </span>
                </span>
              </summary>
              <div className="cmplz-description">
                <span className="cmplz-description-marketing">
                  The technical storage or access is required to create user profiles to send
                  advertising, or to track the user on a website or across several websites for
                  similar marketing purposes.
                </span>
              </div>
            </details>
          </div>
        </div>
        <div className="cmplz-divider cmplz-footer" />
        <div className="cmplz-buttons">
          <button type="button" className="cmplz-btn cmplz-accept">
            Accept
          </button>
          <button type="button" className="cmplz-btn cmplz-deny">
            Deny
          </button>
          <button type="button" className="cmplz-btn cmplz-view-preferences">
            View preferences
          </button>
          <button type="button" className="cmplz-btn cmplz-save-preferences">
            Save preferences
          </button>
        </div>
        <div className="cmplz-links cmplz-documents">
          <a className="cmplz-link" href="https://klang.io/cookie-policy-eu/">
            {t('consent.cookie_policy')}
          </a>
          <a className="cmplz-link" href="https://klang.io/privacy/">
            {t('consent.privacy')}
          </a>
          <a className="cmplz-link" href="https://klang.io/imprint/">
            {t('consent.imprint')}
          </a>
        </div>
      </div>
      <div id="cmplz-manage-consent" data-nosnippet="true">
        <button
          type="button"
          className="cmplz-btn cmplz-hidden cmplz-manage-consent manage-consent-1 cmplz-show"
        >
          Manage consent
        </button>
      </div>
    </>
  );
};

export default ComplianzBanner;
